<div class="container-fluid">
  <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px;">
    <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">← Back</button>
    <h2 style="margin: 0;">{{ 'INDICATOR.RISK_MANAGEMENT' | translate }} — {{ indicatorName }}</h2>
  </div>

  <ntr-datatable
    [actionButtons]="false"
    [data]="data"
    [metaInfo]="metaInfo"
    [entityTitle]="'risk'"
    [disableHeader]="false"
    (onQuery)="onGridQuery($event)"
    (onButtonClick)="onButtonClick($event)"
    [columns]="columns">
  </ntr-datatable>
</div>
